const DocCount = ({ first, last, total }) => {
  return <div>{total > 0 && `${first + 1} - ${last} of ${total} Shown`}</div>;
};

export default DocCount;
